module.exports = __webpack_public_path__ + "teg/media/logo-no-bg.03bc8041.svg";